const removeEmptyEntries = (params = {}) => {
    Object.keys(params).forEach((key) => {
        const value = params[key];
        (value === null || value === undefined || value === '') && delete params[key];
        (Array.isArray(value) && value.length === 0) && delete params[key];
    });

    return params;
};

module.exports = removeEmptyEntries;
